/*  ========================================================================
    # Helpers - BEM
    ========================================================================  */

/**
 * Returns a classes string based on the BEM scheme with optional modifiers and additional classes.
 *
 * @param {string} block - The parent block element including an optional prefix.
 * @param {string} [element=undefined] - The element name which the classes should be applied to.
 * @param {object} [modifiers={}] - An object where the property represent modifiers. The boolean property values define whether the modifier is applied.
 * Example: `{ collapsed: !isCollapsed, 'inverted-scheme': true }`
 * @param {string[]} [additionalClasses=[]] - Additional class names that should be appended after the BEM class names.
 *
 * @returns {string} The resulting classes string.
 */
export default function bem(block, element = undefined, modifiers = {}, additionalClasses = []) {
  const classes = [];

  // Define basename for this element (e. g. s-wysiwyg or c-button__icon).
  const basename = `${block}${element ? `__${element}` : ''}`;
  classes.push(basename);
  // Append modifiers that are set to true.
  if (modifiers instanceof Object) {
    Object.entries(modifiers)
      .filter(([, value]) => !!value)
      .map(([key]) => classes.push(`${basename}--${key}`));
  }

  // Append additional classes, if any.
  if (additionalClasses instanceof Array) {
    classes.push(...additionalClasses);
  }

  return classes.join(' ');
}
